"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Godzilla = void 0;
var imgRoot = "/img/common/konami/";
function Godzilla() {
    console.log("Gojira... is coming");
    var foot = document.createElement('img');
    foot.src = imgRoot + 'godzilla.png';
    var w = window.innerWidth || document.body.clientWidth;
    var h = window.innerHeight || document.body.clientHeight;
    var richterScale = 0;
    var impactPower = 1;
    foot.style.position = 'fixed';
    foot.style.transition = 'all 2s ease-in';
    foot.style.width = (w / 1.5) + 'px';
    foot.style.left = w + 'px';
    foot.style.top = (0 - (h)) + 'px';
    foot.style.transform = 'rotate(60deg)';
    foot.style.zIndex = '-1';
    document.body.appendChild(foot);
    var timeout;
    var impactTimeout;
    var leavesTimeout;
    function footIn() {
        foot.style.left = w / 4 + 'px';
        foot.style.top = '0';
        foot.style.transform = 'rotate(0deg)';
    }
    function footOut() {
        foot.style.left = 0 - (w) + 'px';
        foot.style.top = 0 - (h) + 'px';
        foot.style.transform = 'rotate(-60deg)';
    }
    function shakeDown() {
        jQuery('div, a').each(function () {
            var degrees = (10 - (Math.random() * 20));
            jQuery(this).css('transform', 'rotate(' + degrees + 'deg)');
        });
    }
    function shake() {
        var x = ((richterScale + impactPower) / 2) - (Math.random() * (richterScale * impactPower));
        var y = ((richterScale + impactPower) / 2) - (Math.random() * (richterScale * impactPower));
        document.body.style.position = "relative";
        document.body.style.left = x + 'px';
        document.body.style.top = y + 'px';
        document.body.style.transition = 'left,right .2s';
    }
    function godzillaComes() {
        richterScale += 2;
        if (richterScale < 10) {
            setTimeout(godzillaComes, 2000);
        }
        else {
            clearTimeout(impactTimeout);
            footIn();
            setTimeout(footOut, 4500);
            leavesTimeout = setTimeout(godzillaLeaves, 5000);
        }
    }
    function godzillaLeaves() {
        richterScale -= 1;
        if (richterScale > 0) {
            leavesTimeout = setTimeout(godzillaLeaves, 2000);
        }
        else {
            stopShake();
        }
    }
    function stopShake() {
        clearTimeout(timeout);
        clearTimeout(impactTimeout);
        clearTimeout(leavesTimeout);
        document.body.removeChild(foot);
        document.body.style.position = "";
        document.body.style.left = '0';
        document.body.style.top = '0';
        document.removeEventListener('keyup', undo, false);
        jQuery('div, a').each(function () {
            jQuery(this).css('transform', '');
        });
    }
    function doImpacts() {
        var originalImpactPower = impactPower;
        impactPower *= 5;
        setTimeout(function () { impactPower = originalImpactPower; }, 500);
        clearTimeout(impactTimeout);
        impactTimeout = setTimeout(doImpacts, 2500);
        for (var i = 0; i < 20; ++i) {
            setTimeout(shake, (50 * i));
        }
    }
    function undo(e) {
        if (e.which === 27) {
            stopShake();
        }
    }
    document.addEventListener('keyup', undo, false);
    jQuery(foot).one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
        clearTimeout(impactTimeout);
        doImpacts();
        shakeDown();
    });
    godzillaComes();
    doImpacts();
}
exports.Godzilla = Godzilla;
